export * from './HandLeftAltIcon'
